<div id="feedback__Modal" class="feedback__modal progress__modal" style="display: flex;">
    <!-- Modal content -->
    <div class="modal-content">
        <!-- <div class="popup--close">
            <button (click)="hideModal()"><span class="icon-cross"></span></button>
        </div> -->
        <div class="feedback__Modal--topsection">
            <!-- <p class="mtb1">Nice Job, new check</p> -->
            <h3 class="mtb1-title">Hey, {{user?.firstName}}!</h3>
            <p class="mtb1">Choose your region and timezone to proceed.</p>
            <div class="profile-cont__form--group">
            <div class="phn--outer">
                <div class="phn--ext-new">
            <div class="dropdown">
                <button type="button" [title]="[defaultTimezone]" class="dropbtnTimezone" (click)="showTimezone()"
                    [ngClass]="{'active__arrow': showTimeZone }">{{defaultTimezone}}</button>
                <div id="myDropdownTimezone" class="dropdown-content"
                    [ngClass]="{'show': showTimeZone }">
                    <!--  -->
                    <input type="text" placeholder="Search Country" id="myInputTimezone"
                        (keyup)="filterTimezone($event)" autocomplete="off">
                    <ul>
                        <li class="cursor-pointer" *ngFor="let t of timezoneDrop"
                            attr.data-code="{{t.value}}"
                            (click)="timezoneSelected(t)">
                            {{t.label}}</li>
                    </ul>
                </div>
                <i class="bar"></i>
            </div>
        </div>
    </div>
    <br/>
            </div>
            <p class="mtb1" style="font-size: 14px;" *ngIf="defaultZone">The default timezone is set to <strong> GMT +5:30</strong></p>
            <p class="mtb1"  style="font-size: 14px;" *ngIf="!defaultZone">Selected Timezone is : <strong>{{defaultTimezone}}</strong></p>
        </div>
        <div class="profile-cont__save">
            <button class="light-color link-no-underline blue--button" (click)="setTimeZone()">
                Save
            </button>
        </div>
    </div>
</div>